import { ChevronDown } from "lucide-react";

export const OutcomeDetails = ({ item }) => (
  <>
  {item.samo_pracenje && (
    <p className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800" data-testid="samo-pracenje-notice">
      Prema kurikulumu ovaj se ishod <strong>prati i ne podliježe vrednovanju</strong>. Bilješke će zato biti
      poticajna zapažanja o sudjelovanju, trudu i napretku.
    </p>
  )}
  <details className="group rounded-xl border border-slate-200 bg-slate-50 p-4" data-testid="outcome-details">
    <summary className="flex cursor-pointer list-none items-center justify-between gap-2 text-sm font-medium text-slate-700">
      <span>
        <span className="text-slate-400 mr-1.5">{item.code}</span>
        Razrada ishoda i razina »dobar« iz kurikuluma
      </span>
      <ChevronDown className="h-4 w-4 text-slate-400 transition-transform group-open:rotate-180" />
    </summary>
    <div className="mt-3 space-y-3 text-sm text-slate-600 leading-relaxed">
      <ul className="list-disc pl-5 space-y-1">
        {item.razrada.map((r) => (
          <li key={r}>{r}</li>
        ))}
      </ul>
      <p>
        <strong className="text-slate-700">Razina »dobar« na kraju razreda:</strong> {item.dobar}
      </p>
      {item.napomena && (
        <p data-testid="outcome-napomena">
          <strong className="text-slate-700">Napomena iz kurikuluma:</strong> {item.napomena}
        </p>
      )}
      {item.sadrzaj && (
        <p>
          <strong className="text-slate-700">Sadržaji:</strong> {item.sadrzaj}
        </p>
      )}
    </div>
  </details>
  </>
);

export default OutcomeDetails;
